'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    getZineThumbnail = require('../utils/getZineThumbnail'),
    PropTypes = React.PropTypes;

require('./ZineImage.less');

// sync with sizes.less
var thumbnailSizes = {
  'xsmall': 28, // @UserImage--xsmall
  'small': 32,  // @UserImage--small
  'medium': 44, // @UserImage--medium
  'large': 80,  // @UserImage--large
  'xlarge': 120 // @UserImage--xlarge
};

var ZineImage = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  className: 'ZineImage',

  propTypes: {
    zine: PropTypes.shape({
      thumbnailUrl: PropTypes.string
    }).isRequired,
    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge'])
  },

  getDefaultProps: function () {
    return {
      size: 'medium'
    };
  },

  getCSSModifiers: function () {
    return [this.props.size];
  },

  getThumbnailUrl: function () {
    var thumbnail = getZineThumbnail(this.props.zine),
        size = thumbnailSizes[this.props.size];

    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    if (devicePixelRatio > 1.5) {
      size *= 2;
    }

    return getThumbnailUrl(thumbnail, {
      allowExternal: true,
      allowEmpty: true,
      mode: 'scale_crop',
      width: size,
      height: size
    });
  },

  render: function () {
    var style = {},
        url = this.getThumbnailUrl();

    if (url) {
      style.backgroundImage = 'url(' + url  + ')';
    }

    return (
      <div className={this.getClassName()}
           style={style} />
    );
  }
});

module.exports = ZineImage;



/** WEBPACK FOOTER **
 ** ./atoms/ZineImage.jsx
 **/